<template>
  <div>
    <Header>
      <template #title>{{ gatewayTitle }}</template>

      <template #actions>
        <a :href="gatewayRegisterLink" target="_blank">
          <BaseButton color="green-6" variant="primary" size="md" icon="plus">
            {{ $t("online_payment.guide.register_btn") }}
          </BaseButton>
        </a>
      </template>
    </Header>

    <IQOSHorizontalScroll v-if="!forcedGateway">
      <div class="payment-gateways">
        <PaymentGatewayCard
          v-for="(gateway, idx) in supportedGateways"
          :key="gateway"
          :background="backgrounds[gateway]"
          :commision="comissions[gateway]"
          :color="colors[gateway]"
          :active="gateway == selected_gateway"
          :getawayTarget="targets[gateway]"
          :logo="`/icons/${icons[gateway]}`"
          @click="(selected_gateway = gateway), (index = idx + 1)"
        />
      </div>

      <template #actions> </template>
    </IQOSHorizontalScroll>
    <BaseDivider color="v1-grey-4" />
    <PageContainer>
      <!-- <BaseDivider color="v1-grey-4" class="mt-24 mb-24" /> -->
      <IQOS required class="w-100" v-if="false">
        <div class="iqos-comment qrw-paragraph-md">
          {{ $t("online_payment.start.desc") }}
        </div>
        <!-- <BaseButton
            variant="secondary"
            size="md"
            color="green-5"
            @click="addEmptyMerchant"
            class="mt-16"
          >
            {{ $t("online_payment.start.action") }}
          </BaseButton> -->
      </IQOS>

      <div
        class="single-merchant-settings"
        :class="{
          'mt-24': midx != 0,
        }"
        v-for="(merchant, midx) in filteredMerchants"
        :key="merchant._id"
      >
        <!-- <BaseDivider color="v1-grey-4" class="mb-16 mt-16"/> -->
        <div class="action-buttons">
          <BaseButton
            variant="secondary"
            color="red-4"
            size="lg"
            icon="trash"
            @click="remove_id = merchant._id"
          >
            {{ $t("online_payment.delete_merchant") }}
          </BaseButton>
        </div>
        <div class="iqos-grid mt-16">
          <div class="iqos-column">
            <CompanyDetailsPanel
              :merchant="merchant"
              @update="onMerchantUpdated"
            />
          </div>
          <div class="iqos-column">
            <MerchantApiKeysPanel
              :merchant="merchant"
              @update="onMerchantUpdated"
            />

            <MerchantMenus :merchant="merchant" />
          </div>
        </div>

        <BaseDivider color="v1-grey-4" class="mt-16" />
      </div>

      <div class="add-merchant-block w-100 mt-16">
        <BaseButton
          @click="addEmptyMerchant"
          variant="secondary"
          color="v1-grey-10"
          size="lg"
          icon="plus"
        >
          {{ $t("online_payment.guide.add_btn") }}
        </BaseButton>
      </div>

      <div class="add-merchant-hint w-100 qrw-paragraph-md v1-grey-6-color mt-24">
        {{ $t("online_payment.guide.add_btn_hint") }}
      </div>
    </PageContainer>

    <DangerConfirmModal
      @confirm="removePayReceiver"
      @cancel="remove_id = null"
      v-if="remove_id"
    >
      {{ $t("settings_cafe.liqpay.confirm_remove") }}
    </DangerConfirmModal>

    <GuidePopUp
      :gateway="selected_gateway"
      @close="isGuideActive = false"
      v-if="isGuideActive"
    />
  </div>
</template>

<script>
import CompanyDetailsPanel from "@/components/payment/CompanyDetailsPanel.vue";
import MerchantApiKeysPanel from "@/components/payment/MerchantApiKeysPanel.vue";
import PaymentGatewayCard from "@/components/payment/PaymentGatewayCard.vue";
import MerchantGuidePanel from "@/components/payment/MerchantGuidePanel.vue";
import GuidePopUp from "@/components/payment/GuidePopUp.vue";
import StripeConnectPanel from "@/components/payment/StripeConnectPanel.vue";
import MerchantMenus from "@/components/payment/MerchantMenus.vue";

import PaymentAPI from "@/api/payment";
import MenuAPI from "@/api/menu";

export default {
  data() {
    return {
      index: 1,
      selected_gateway: null,
      pay_receivers: [],
      remove_id: null,
      isGuideActive: false,

      backgrounds: {
        liqpay: "#1d1d1b",
        wayforpay: "#e4efff",
        stripe: "#6722e5",
        payu: "#ededed",
        yookassa: "#1d1d1b",
        touchcard: "#ededed",
        fondy: "#1d1d1b",
        interkassa: "#ededed",
      },

      targets: {
        liqpay: "pb_target",
        wayforpay: "any_target",
        stripe: "any_target",
        payu: "any_target",
        yookassa: "any_target",
        touchcard: "any_target",
        fondy: "any_target",
        interkassa: "any_target",
      },

      colors: {
        liqpay: "#ededed",
        wayforpay: "#464646",
        stripe: "#ededed",
        payu: "#464646",
        yookassa: "#ededed",
        touchcard: "#464646",
        fondy: "#ededed",
        interkassa: "#1d1d1b",
      },

      icons: {
        liqpay: "liqpay.svg",
        stripe: "stripe.svg",
        wayforpay: "wayforpay.png",
        yookassa: "yookassa.svg",
        payu: "payu.png",
        touchcard: "touchcard.svg",
        fondy: "fondy_dark.png",
        interkassa: "interkassa.png",
      },

      comissions: {
        liqpay: "2.75%",
        wayforpay: "2.5%",
        stripe: "2.5%+",
        payu: "2% + GST",
        yookassa: "3%",
        touchcard: "2.5%",
        fondy: "2.7%",
        interkassa: "1.9%+",
      },
    };
  },
  watch: {
    isGuideActive() {
      if (this.isGuideActive) {
        document.documentElement.style.overflow = "hidden";
        return;
      }
      document.documentElement.style.overflow = "auto";
    },
    '$route.params.gateway'() {
      if (this.forcedGateway) {
        this.selected_gateway = this.forcedGateway;
      }

      this.fetchList();
    }
  },
  methods: {
    scrollGetaweys(direction) {
      let el = document.getElementsByClassName("payment-getawey")[0];
      let element = document.getElementById("payment-getaway");
      let style = window.getComputedStyle(el);
      let elWidth = el.offsetWidth + parseFloat(style.marginRight);

      if (direction == "left" && this.index > 1) {
        element.scrollLeft -= elWidth;
        this.index -= 1;
        this.selected_gateway = this.supportedGateways[this.index - 1];
      } else if (this.index < this.supportedGateways.length) {
        element.scrollLeft += elWidth;
        this.index += 1;
        this.selected_gateway = this.supportedGateways[this.index - 1];
      }
    },
    isGatewaySupported(gateway) {
      return this.$store.getters["worldwide/checkPaymentGateway"](gateway);
    },
    fetchList() {
      PaymentAPI.getPayReceivers(this.$store.state.cafe._id)
        .then((data) => {
          this.pay_receivers = data.pay_receivers;
          this.$store.commit("setPayReceivers", this.pay_receivers);
        })
        .catch((error) => {
          this.$store.dispatch("showError", "payment_error");
        });
    },
    addEmptyMerchant() {
      PaymentAPI.createPayReceiver({
        gateway: this.selected_gateway,
        cafe_id: this.cafe._id,
      })
        .then((data) => {
          this.fetchList();

          this.$store.dispatch("auditlog/write", {
            type: "add_online_merchant",
            payload: {
              gateway: this.selected_gateway,
              cafe_id: this.cafe._id,
            },
          });
        })
        .catch((error) => {
          this.$store.dispatch("showError", "payment_error");
        });
    },
    onMerchantUpdated(id, data) {
      PaymentAPI.updatePayReceiver(id, data)
        .then((data) => {
          this.fetchList();

          this.$store.dispatch("auditlog/write", {
            type: "update_online_merchant",
            payload: {
              id,
            },
          });
        })
        .catch((error) => {
          this.$store.dispatch("showError", "payment_error");
        });
    },
    removePayReceiver() {
      PaymentAPI.removePayReceiver(this.remove_id)
        .then((data) => {
          this.fetchList();

          this.$store.dispatch("auditlog/write", {
            type: "remove_online_merchant",
            payload: {
              id: this.remove_id,
            },
          });

          this.remove_id = null;
        })
        .catch((error) => {
          this.$store.dispatch("showError", "payment_error");
        });
    },
    fetchMenus() {
      let promise = null;

      if (this.$store.state.selected_chain) {
        promise = MenuAPI.getWithSettingsOnly(
          null,
          this.$store.state.selected_chain._id
        );
      } else {
        promise = MenuAPI.getWithSettingsOnly(this.cafe._id);
      }
      promise
        .then((data) => {
          this.$store.commit('setPaymentMenusBuffer', data.menus);
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  computed: {
    supportedGateways() {
      return this.$store.state.worldwide.region.payment_gateways;
    },
    gatewayRegisterLink() {
      const links = {
        liqpay: "https://www.liqpay.ua/uk/registration",
        wayforpay: "https://wayforpay.com",
        payu: "https://corporate.payu.com",
        yookassa: "https://yookassa.ru/joinups",
        stripe: "https://stripe.com/",
        touchcard: "https://touchcard.tech/#fedback",
        fondy:
          this.owner.language == "ru" ? "https://fondy.ru" : "https://fondy.ua",
        interkassa: "https://www.interkassa.com/registration",
        tinkoff: 'https://www.tinkoff.ru/kassa/solution/classic/'
      };

      return links[this.selected_gateway];
    },
    filteredMerchants() {
      return this.pay_receivers.filter(
        (p) => p.gateway == this.selected_gateway
      );
    },
    cafe() {
      return this.$store.state.cafe;
    },
    owner() {
      return this.$store.state.owner;
    },
    forcedGateway() {
      return this.$route.params.gateway;
    },
    gatewayTitle() {
      if (!this.selected_gateway) return "";
      return (
        this.selected_gateway.substring(0, 1).toUpperCase() +
        this.selected_gateway.substring(1)
      );
    },
  },
  mounted() {
    this.selected_gateway = this.supportedGateways[0];

    if (this.forcedGateway) {
      this.selected_gateway = this.forcedGateway;
    }

    this.fetchList();
    this.fetchMenus();
  },
  components: {
    CompanyDetailsPanel,
    MerchantApiKeysPanel,
    MerchantGuidePanel,
    PaymentGatewayCard,
    GuidePopUp,
    StripeConnectPanel,
    MerchantMenus,
  },
};
</script>

<style scoped>
.payment-gateways-container {
  display: table-row;
}
.line {
  width: 100%;
  margin: 3.333vh 0 0;
}
.payment-gateways {
  display: flex;
}
.merchant-not-active {
  padding: 0 3.507vw;
}
.create-merchant {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #1d1d1b;
  border-radius: 12px;
  padding: 2.222vh 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.info-message {
  font-weight: normal;
  font-size: 1.666vh;
  line-height: 1.888vh;
  color: #ededed;
  margin-bottom: 3.333vh;
}
.payment-getawey-controls {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
#payment-getaway {
  max-width: 100%;
  overflow: auto;
  scroll-behavior: smooth;
}
.arrow {
  width: 6.666vh;
  height: 3.555vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1d1d1b;
  border-radius: 4px 0 0 4px;
}
.arrow img {
  width: 1.111vh;
  height: 2.222vh;
}

.payment-gateway.wayforpay,
.payment-gateway.payu,
.payment-gateway.stripe,
.payment-gateway.yookassa {
  background-color: #ededed;
  /* border: 3px solid transparent; */
}

.arrow:last-child {
  transform: rotate(180deg);
  border-radius: 4px 0 0 4px;
  border-right: 1px solid #464646;
}

.add {
  width: 32.778vw;
}

.gateway-icon.stripe {
  width: 10vh;
}

.action-buttons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.add-merchant-block {
  width: 100%;
  display: flex;
  justify-content: center;
}

.add-merchant-hint {
  text-align: center;
}

a {
  text-decoration: none;
}
</style>
